import React from "react";
import ImgixFluidImage from "../../newComponents/ImgixFluidImage";

const Image = ({ block, last }) => {
  const image = block.image[0];
  let styles = ``;
  switch (block.position) {
    case "left":
      styles = `lg:float-left lg:mr-8 lg:w-${block.width && block.width !== "full" ? block.width : "1/3"}`;
      break;
    case "right":
      styles = `lg:float-right lg:ml-8 lg:w-${block.width && block.width !== "full" ? block.width : "1/3"}`;
      break;
    default:
      break;
  }

  let ar = "";
  switch (block.aspectRatio) {
    case "16:9":
      ar = 16/9;
      break;
    case "4:3":
      ar = 4/3
      break;
    case "3:2":
      ar = 3/2;
      break;
    case "1:1":
      ar = 1;
      break;
    default:
      ar = false;
      break;
  }

  const finalImage = image ?
    <figure className={`${styles} ${last ? "" : "mb-7 lg:mb-5"}`}>
      <ImgixFluidImage attribution={image.attribution} image={image} ar={ar || image.width / image.height} focalPoint={image.focalPoint} />
      {/* Assets are elements, so they can have fields attached to them. In this project, we've included an optional Caption field. */}
      {image.caption && <figcaption className="text-sm text-gray-600 px-1 pt-2" dangerouslySetInnerHTML={{ __html: image.caption }}/>}
    </figure>
    :
    <div>Image not found...</div>

  return (
    <section>
      <div className="shell">
        {block.imageLink ? <a href={block.imageLink}>{finalImage}</a> : finalImage}
      </div>
    </section>
  );
}

export default Image;
